/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreatePhotoPdaDto } from '../models/create-photo-pda-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PhotoPdaDto } from '../models/photo-pda-dto';


/**
 * Fonctions de gestion des photos envoyées depuis le PDA
 */
@Injectable({
  providedIn: 'root',
})
export class PhotosPdaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation photoPdaGetList
   */
  static readonly PhotoPdaGetListPath = '/api/photos-pda/list';

  /**
   * Renvoie la liste des photoPdas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `photoPdaGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  photoPdaGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PhotoPdaDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PhotosPdaService.PhotoPdaGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PhotoPdaDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des photoPdas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `photoPdaGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  photoPdaGetList(params?: {
  }): Observable<Array<PhotoPdaDto>> {

    return this.photoPdaGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PhotoPdaDto>>) => r.body as Array<PhotoPdaDto>)
    );
  }

  /**
   * Path part for operation photoPdaLoadList
   */
  static readonly PhotoPdaLoadListPath = '/api/photos-pda/load-list';

  /**
   * Renvoie la liste des photoPdas (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `photoPdaLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  photoPdaLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PhotosPdaService.PhotoPdaLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des photoPdas (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `photoPdaLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  photoPdaLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.photoPdaLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation photoPdaGet
   */
  static readonly PhotoPdaGetPath = '/api/photos-pda/{id}';

  /**
   * Renvoie la photoPda spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `photoPdaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  photoPdaGet$Response(params: {

    /**
     * Identifiant de la photoPda
     */
    id: number;
  }): Observable<StrictHttpResponse<PhotoPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, PhotosPdaService.PhotoPdaGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PhotoPdaDto>;
      })
    );
  }

  /**
   * Renvoie la photoPda spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `photoPdaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  photoPdaGet(params: {

    /**
     * Identifiant de la photoPda
     */
    id: number;
  }): Observable<PhotoPdaDto> {

    return this.photoPdaGet$Response(params).pipe(
      map((r: StrictHttpResponse<PhotoPdaDto>) => r.body as PhotoPdaDto)
    );
  }

  /**
   * Path part for operation photoPdaPut
   */
  static readonly PhotoPdaPutPath = '/api/photos-pda/{id}';

  /**
   * Met à jour la photoPda spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `photoPdaPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  photoPdaPut$Response(params: {

    /**
     * Identifiant de la photoPda à mettre à jour
     */
    id: number;

    /**
     * PhotoPda
     */
    body: PhotoPdaDto
  }): Observable<StrictHttpResponse<PhotoPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, PhotosPdaService.PhotoPdaPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PhotoPdaDto>;
      })
    );
  }

  /**
   * Met à jour la photoPda spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `photoPdaPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  photoPdaPut(params: {

    /**
     * Identifiant de la photoPda à mettre à jour
     */
    id: number;

    /**
     * PhotoPda
     */
    body: PhotoPdaDto
  }): Observable<PhotoPdaDto> {

    return this.photoPdaPut$Response(params).pipe(
      map((r: StrictHttpResponse<PhotoPdaDto>) => r.body as PhotoPdaDto)
    );
  }

  /**
   * Path part for operation photoPdaDelete
   */
  static readonly PhotoPdaDeletePath = '/api/photos-pda/{id}';

  /**
   * Supprime la photoPda spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `photoPdaDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  photoPdaDelete$Response(params: {

    /**
     * Identifiant de la photoPda à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, PhotosPdaService.PhotoPdaDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la photoPda spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `photoPdaDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  photoPdaDelete(params: {

    /**
     * Identifiant de la photoPda à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.photoPdaDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation photoPdaPost
   */
  static readonly PhotoPdaPostPath = '/api/photos-pda';

  /**
   * Crée la photoPda spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `photoPdaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  photoPdaPost$Response(params: {

    /**
     * PhotoPda
     */
    body: PhotoPdaDto
  }): Observable<StrictHttpResponse<PhotoPdaDto>> {

    const rb = new RequestBuilder(this.rootUrl, PhotosPdaService.PhotoPdaPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PhotoPdaDto>;
      })
    );
  }

  /**
   * Crée la photoPda spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `photoPdaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  photoPdaPost(params: {

    /**
     * PhotoPda
     */
    body: PhotoPdaDto
  }): Observable<PhotoPdaDto> {

    return this.photoPdaPost$Response(params).pipe(
      map((r: StrictHttpResponse<PhotoPdaDto>) => r.body as PhotoPdaDto)
    );
  }

  /**
   * Path part for operation photoPdaGetPhotoPda
   */
  static readonly PhotoPdaGetPhotoPdaPath = '/api/photos-pda/photo/{photoPdaId}';

  /**
   * Télécharge la photo spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `photoPdaGetPhotoPda()` instead.
   *
   * This method doesn't expect any request body.
   */
  photoPdaGetPhotoPda$Response(params: {

    /**
     * Identifiant de la photoPda
     */
    photoPdaId: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PhotosPdaService.PhotoPdaGetPhotoPdaPath, 'get');
    if (params) {
      rb.path('photoPdaId', params.photoPdaId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Télécharge la photo spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `photoPdaGetPhotoPda$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  photoPdaGetPhotoPda(params: {

    /**
     * Identifiant de la photoPda
     */
    photoPdaId: number;
  }): Observable<Blob> {

    return this.photoPdaGetPhotoPda$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation photoPdaAddPhotoPdas
   */
  static readonly PhotoPdaAddPhotoPdasPath = '/api/photos-pda/{id}/photos';

  /**
   * Ajoute des photos
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `photoPdaAddPhotoPdas()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  photoPdaAddPhotoPdas$Response(params: {

    /**
     * Identifiant du parc
     */
    id: number;

    /**
     * Données des photos envoyées
     */
    body: Array<CreatePhotoPdaDto>
  }): Observable<StrictHttpResponse<Array<PhotoPdaDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PhotosPdaService.PhotoPdaAddPhotoPdasPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PhotoPdaDto>>;
      })
    );
  }

  /**
   * Ajoute des photos
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `photoPdaAddPhotoPdas$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  photoPdaAddPhotoPdas(params: {

    /**
     * Identifiant du parc
     */
    id: number;

    /**
     * Données des photos envoyées
     */
    body: Array<CreatePhotoPdaDto>
  }): Observable<Array<PhotoPdaDto>> {

    return this.photoPdaAddPhotoPdas$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PhotoPdaDto>>) => r.body as Array<PhotoPdaDto>)
    );
  }

}
